import React from 'react';
import { useTranslate, SelectField } from 'react-admin';


export const SelectEnumField = ({enumObj, enumName, translate = true, ...props}) => {
	const translator = useTranslate();
	// TODO: find out more better approach to translate enum
	const choices = translate ? Object.keys(enumObj).map(key => (
		props.reverse ? {id: parseInt(key), name: translator(`osfc.enums.${enumName}.${enumObj[key]}`)} : {id: enumObj[key], name: translator(`osfc.enums.${enumName}.${key}`)}
	)) :
		Object.keys(enumObj).map(key => (
			props.reverse ? {id: parseInt(key), name:enumObj[key]} : {id: enumObj[key], name:key}
		));
	return (
		<SelectField
			{...props}
			choices={choices}			// parse={parse}
		/>
	);
};


SelectEnumField.defaultProps = {
	addLabel: true,
};
